/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React from 'react';
import PropTypes from 'prop-types';

// @mui material components
import Icon from '@mui/material/Icon';

export default function PurchaseOrderStepper({ icon, completed }) {
  const icons_complete = {
    1: <Icon color='info'>border_color</Icon>,
    2: <Icon color='info'>price_check</Icon>,
    3: <Icon color='info'>task_alt</Icon>,
    4: <Icon color='info'>task_alt</Icon>,
    5: <Icon color='error'>highlight_off_outlined</Icon>,
    6: <Icon color='info'>task_alt</Icon>,
    7: <Icon color='info'>task_alt</Icon>,
    8: <Icon color='info'>task_alt</Icon>,
    9: <Icon color='error'>cancel</Icon>,
  };
  const icons = {
    1: <Icon color='disabled'>border_color</Icon>,
    2: <Icon color='disabled'>price_check</Icon>,
    3: <Icon color='disabled'>task_alt</Icon>,
    4: <Icon color='disabled'>task_alt</Icon>,
    5: <Icon color='disabled'>cancel</Icon>,
    6: <Icon color='disabled'>task_alt</Icon>,
    7: <Icon color='disabled'>task_alt</Icon>,
    8: <Icon color='disabled'>task_alt</Icon>,
    9: <Icon color='disabled'>cancel</Icon>,
  };
  return <div>{completed ? icons_complete[String(icon)] : icons[String(icon)]}</div>;
}

PurchaseOrderStepper.propTypes = {
  icon: PropTypes.node.isRequired,
  completed: PropTypes.bool.isRequired,
};
